import { APP_CURRENT_VERSION } from '../constants';

/**
 * @memberof module:util
 * @function
 * @name isAppUpdateAvailable
 * @description check for whether new web app version is available
 *
 * @returns {boolean}
 *
 * @example
 * console.log(isAppUpdateAvailable()); //true, new web app update available
 * console.log(isAppUpdateAvailable()); //false, new web app update is NOT available. Current version is latest version.
 */

export const isAppUpdateAvailable = async () => {
  let appUpdateAvailable = false; //make it false in prod
  try {
    // Bypass the service-worker precache + HTTP cache for the version probe —
    // otherwise the stale SW could serve an old meta.json and we'd never detect
    // the update. Cache-busting query + no-store both keep this hitting network.
    let res = await fetch(`/meta.json?ts=${Date.now()}`, { cache: 'no-store' });
    let meta = await res.json();

    const latestVersion = meta.version || '';
    const currentVersion = APP_CURRENT_VERSION || '';



    const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
    if (shouldForceRefresh) {
      console.log(
        `We have a new version - ${latestVersion}. Should force refresh`
      );

      appUpdateAvailable = true;
    } else {


      appUpdateAvailable = false; //make it false in prod
    }
  } catch (err) {
    console.log('err while getting meta.json from remote');
  }

  return appUpdateAvailable;
};

// versionA from `meta.json` - first param - latest version
// versionB in bundle file - second param - current version
const semverGreaterThan = (versionA, versionB) => {
  const versionsA = versionA.split(/\./g);

  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());

    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b); //should force load the browser tab
  }
  return false; //make it false in prod, it means should force load the browser tab
};
